import { createStore } from 'vuex';
import user from './modules/user';
import app from './modules/app';
import file from './modules/file';
import chat from './modules/chat'
import yjApp from './modules/yj_app';
const store = createStore({
    modules: {
        user,
        app,
        file,
        yjApp,
        chat
    },
});

export default store;